//@ts-ignore
import Swiper, { Pagination, Navigation } from "swiper";

const init = () => {
  Swiper.use([Pagination, Navigation]);

  const slider = new Swiper("[data-filou-festivals-images-slider]", {
    slidesPerView: "auto",
    spaceBetween: 64,
    loop: false,

    pagination: {
      el: "[data-swiper-pagination]",
      clickable: true,
      bulletActiveClass: "active",
      bulletClass: "bullet",
    },

    navigation: {
      nextEl: "[data-filou-festivals-images-slider] [data-swiper-navigation-next]",
      prevEl: "[data-filou-festivals-images-slider] [data-swiper-navigation-prev]",
    },
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
